import { Component, Input } from '@angular/core';
import { IconsModule } from '@bcef/ia-ng-icons';

@Component({
  selector: 'ia-resil-contrats-error-message',
  templateUrl: './error-message.component.html',
  imports: [IconsModule],
  standalone: true,
})
export class ErrorMessageComponent {
  @Input() public message = '';
}
